/**
 * Formats a given date into a readable string.
 * @param {string | Date} date - The date to format.
 * @param {Object} options - Formatting options for the date.
 * @returns {string} - The formatted date string.
 */
export const formatDate = (date, options = { month: "long", year: "numeric" }) => {
    const inputDate = new Date(date);
    return inputDate.toLocaleDateString("en-US", options);
  };